module.exports = __webpack_public_path__ + "img/zhangjie.7c2d09c1.png";